import React from 'react';
import { Link } from 'react-router-dom';
import { IMAGES, bgStyle } from '@/config/images';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Target, ArrowRight } from 'lucide-react';

const Print3DProjectPicker = () => {
  return (
    <div
      className="min-h-screen -m-4 lg:-m-6 p-4 lg:p-6"
      style={bgStyle(IMAGES.PRINTING3D_DASHBOARD)}
    >
      <div className="fixed inset-0 bg-black/70 -z-10" style={{ pointerEvents: 'none' }} />

      <div className="max-w-4xl mx-auto space-y-6">
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-orange-500 mb-2">Tools</div>
          <h1
            className="text-3xl md:text-4xl font-bold text-orange-500 tracking-tight uppercase"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            Project Picker
          </h1>
          <p className="mt-2 text-sm text-zinc-300">
            Get material and settings recommendations for your 3D printing project type.
          </p>
        </div>

        <Card className="bg-black/60 border-zinc-700">
          <CardContent className="py-10 text-center space-y-4">
            <Target className="w-12 h-12 text-zinc-600 mx-auto" />
            <p className="text-zinc-400">Project Picker coming soon.</p>
            <Link to="/3d-printing/calculator">
              <Button variant="outline" className="border-orange-500 text-orange-400 hover:bg-orange-500/10">
                Use the Print Calculator
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Print3DProjectPicker;
